"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashmixValidationClassRegistry = exports.DashmixTheme = void 0;
var DashmixTheme;
(function (DashmixTheme) {
    DashmixTheme["Default"] = "default";
    DashmixTheme["Danger"] = "danger";
    DashmixTheme["Dark"] = "dark";
    DashmixTheme["Info"] = "info";
    DashmixTheme["Light"] = "light";
    DashmixTheme["Primary"] = "primary";
    DashmixTheme["Success"] = "success";
    DashmixTheme["Warning"] = "warning";
})(DashmixTheme = exports.DashmixTheme || (exports.DashmixTheme = {}));
exports.dashmixValidationClassRegistry = {
    invalid: 'is-invalid',
    valid: 'is-valid'
};
//# sourceMappingURL=common.js.map